import { getExerciseTypeVersionAdapter } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('VisualExercise', 'v1');
export default exerciseTypeVersionAdapter;